import { render } from "./SciencePage.vue?vue&type=template&id=3b2f1eaf"
import script from "./SciencePage.vue?vue&type=script&lang=js"
export * from "./SciencePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__